// extracted by mini-css-extract-plugin
export default {"header":"FilterAge_header__prnwh"};